import { changeLocale as originalF, useIntl } from 'gatsby-plugin-intl';

export const changeLocale = originalF;
export const useIntlData = useIntl;
